import { useContext } from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import { Config, formatPrice, I18n } from '@deporvillage/utils-library-component';

import styles from './CartError.module.scss';

const getItemPrice = (item, keyPrice) => (
    item.variants.length ? (
        item?.variants?.[0]?.items.find(({ id }) => id === item.selectedOption)?.price?.[keyPrice]
    ) : (
        item.default_variant.price[keyPrice]
    )
);

const CartError = ({ items, onClose }) => {
    const { lang } = useContext(Config);
    return (
        <div className={styles['cart-error']}>
            <div className={`${styles['cart-error-title']}`}>
                <span className={`${styles['icon-cancel']} icon icon-cancel`} />
                <span className={styles['cart-error-title-text']}>
                    {
                        items.length > 1 ? (
                            <I18n>product_page.errors.items_not_added_to_cart</I18n>
                        ) : (
                            <I18n>product_page.errors.item_not_added_to_cart</I18n>
                        )
                    }
                </span>
            </div>
            {
                items.map((item) => (
                    <a
                        key={item.id}
                        data-testid={`${item.id}-cart-product`}
                        className={styles['list-item']}
                    >
                        <Picture
                            src={`product/${item.gallery_images?.images[item.gallery_images.default]}`}
                            name={item.title}
                            width={70}
                            height={70}
                        />

                        <div className={styles['list-item-content']}>
                            <span className={styles['item-quantity']}>{item.quantity} x </span>
                            <span className={styles['item-title']}>{item.title}</span>
                            {
                                item?.variants?.length ? item.variants.map((variant) => (
                                    <div key={variant.id} className={styles['text-variant']}>
                                        <I18n>cart_page.title.size</I18n>:{' '}
                                        {
                                            variant.items.find(
                                                (itemVariant) =>
                                                    itemVariant.id === item.selectedOption,
                                            ).name
                                        }
                                    </div>
                                )) : null
                            }
                            <div className={styles['item-error']}>
                                <I18n>product_page.errors.item_or_size_out_of_stock</I18n>
                            </div>
                        </div>
                        <div
                            className={
                                `${styles.price} ${
                                    item.default_variant.price.pvp &&
                                        item.default_variant.price.pvp !==
                                            item.default_variant.price.price ? (
                                                styles['with-pvp']
                                            ) : (
                                                ''
                                            )
                                }`
                            }
                        >
                            {
                                item.default_variant.price.pvp && item.default_variant.price.pvp !==
                                    item.default_variant.price.price ? (
                                        <del className={styles['price-pvpr']}>
                                            <I18n
                                                args={{
                                                    pvp: formatPrice(
                                                        getItemPrice(item, 'pvp'),
                                                        item.default_variant.price.currency_code,
                                                        lang,
                                                    ),
                                                }}
                                            >
                                                cart_page.pricing.pvp
                                            </I18n>
                                        </del>
                                    ) : null
                            }

                            {
                                formatPrice(
                                    getItemPrice(item, 'price'),
                                    item.default_variant.price.currency_code,
                                    lang,
                                )
                            }
                        </div>
                    </a>
                ))
            }
            <div>
                <button onClick={onClose} className={`${styles['checkout-cart-button']}`}>
                    <span>
                        <I18n>product_page.actions.back_to_cart</I18n>
                    </span>
                </button>
            </div>
        </div>
    );
};

CartError.propTypes = {
    items: PropTypes.array,
    onClose: PropTypes.func,
};

export default CartError;
